// import { Badge, ProgressBar } from "react-bootstrap";
// import { createModel } from "../common/UniversalCSVXLSXImporter";

// export const getShelfConfig = (
//     externalData = {},
//     props = {},
//     permissions = {}
// ) => {

//     const ShelfModel = createModel({
//         modelName: "Shelf",
//         fields: {
//             name: "Name",
//             floor: "Floor",
//             rack: "Rack",
//             shelf: "Shelf",
//             classification_type: "Classification Type",
//             classification_from: "From Range",
//             classification_to: "To Range",
//             capacity: "Capacity",
//             full_location_code: "Full Location Code",
//             is_active: "Active"
//         },
//         required: ["name", "floor", "rack", "shelf"]
//     });

//     // Get library settings from external data
//     const librarySettings = externalData?.["librarysettings"] || [];
//     console.log("librarysetting",librarySettings)
//     // Looking at backend router, it could be an array or { success, data }
//     const settings = Array.isArray(librarySettings) ? librarySettings[0] : (librarySettings.data || {});
//     const configClassification = settings?.config_classification || "";
//     console.log("coinfi-->",configClassification)
//     return {
//         moduleName: "shelf",
//         moduleLabel: "Rack Mapping",
//         apiEndpoint: "shelf",

//         dataDependencies: {
//             librarysettings: 'librarysettings'
//         },

//         importMatchFields: ["name", "floor", "rack"],
//         importModel: ShelfModel,

//         initialFormData: (editingItem) => {
//             if (editingItem) {
//                 return {
//                     name: editingItem.name || "",
//                     floor: editingItem.floor || "",
//                     rack: editingItem.rack || "",
//                     shelf: editingItem.shelf || "",
//                     classification_type: editingItem.classification_type || "",
//                     classification_from: editingItem.classification_from || "",
//                     classification_to: editingItem.classification_to || "",
//                     capacity: editingItem.capacity || 100,
//                     is_active: editingItem.is_active !== undefined ? editingItem.is_active : true
//                 };
//             }

//             return {
//                 name: "",
//                 floor: "",
//                 rack: "",
//                 shelf: "",
//                 classification_type: "",
//                 classification_from: "",
//                 classification_to: "",
//                 capacity: 100,
//                 is_active: true
//             };
//         },

//         columns: [
//             {
//                 field: "name",
//                 label: "Name",
//                 width: "200px",
//             },
//             {
//                 field: "floor",
//                 label: "Floor",
//                 width: "100px",
//                 render: (value) => <span className="font-monospace">{value || '-'}</span>,
//             },
//             {
//                 field: "rack",
//                 label: "Rack",
//                 width: "100px",
//                 render: (value) => <span className="font-monospace">{value || '-'}</span>,
//             },
//             {
//                 field: "shelf",
//                 label: "Shelf",
//                 width: "100px",
//                 render: (value) => <span className="font-monospace">{value || '-'}</span>,
//             },
//             {
//                 field: "classification_type",
//                 label: "Type",
//                 width: "100px",
//                 render: (value) => <span className="badge bg-info">{value || '-'}</span>,
//             },
//             {
//                 field: "classification_from",
//                 label: "From",
//                 width: "80px",
//                 render: (value) => <span className="text-info font-monospace">{value || '-'}</span>,
//             },
//             {
//                 field: "classification_to",
//                 label: "To",
//                 width: "80px",
//                 render: (value) => <span className="text-info font-monospace">{value || '-'}</span>,
//             },
//             {
//                 field: "full_location_code",
//                 label: "Location",
//                 width: "150px",
//                 render: (value) => <span className="font-monospace">{value || '-'}</span>,
//             },
//             {
//                 field: "capacity",
//                 label: "Capacity",
//                 width: "150px",
//                 render: (value) => {
//                     const capacity = parseInt(value) || 100;
//                     return (
//                         <span>{capacity}</span>
//                     );
//                 }
//             },
//             {
//                 field: "is_active",
//                 label: "Active",
//                 width: "100px",
//                 render: (value) => (
//                     <Badge bg={value ? "success" : "danger"}>
//                         {value ? "Active" : "Inactive"}
//                     </Badge>
//                 )
//             }
//         ],

//         formFields: [
//             {
//                 name: "floor",
//                 label: "Floor",
//                 type: "text",
//                 required: true,
//                 placeholder: "Enter floor",
//                 colSize: 6,
//                 onChange: (value, formData, setFormData, setFieldState) => {
//                     // Update full location code when floor changes
//                     const locationCode = `${value || ''}-${formData.rack || ''}-${formData.shelf || ''}`;
//                     setFormData(prev => ({
//                         ...prev,
//                         floor: value,
//                         full_location_code: locationCode
//                     }));
//                     if (setFieldState) {
//                         setFieldState('full_location_code', {
//                             helpText: `Generated: ${locationCode}`
//                         });
//                     }
//                 }
//             },
//             {
//                 name: "rack",
//                 label: "Rack",
//                 type: "text",
//                 required: true,
//                 placeholder: "Enter rack number (e.g., RACK-01)",
//                 colSize: 6,
//                 onChange: (value, formData, setFormData, setFieldState) => {
//                     // Update full location code when rack changes
//                     const locationCode = `${formData.floor || ''}-${value || ''}-${formData.shelf || ''}`;
//                     setFormData(prev => ({
//                         ...prev,
//                         rack: value,
//                         full_location_code: locationCode
//                     }));
//                     if (setFieldState) {
//                         setFieldState('full_location_code', {
//                             helpText: `Generated: ${locationCode}`
//                         });
//                     }
//                 }
//             },
//             {
//                 name: "shelf",
//                 label: "Shelf",
//                 type: "text",
//                 required: true,
//                 placeholder: "Enter shelf (e.g., SHELF-A)",
//                 colSize: 6,
//                 onChange: (value, formData, setFormData, setFieldState) => {
//                     // Update full location code when shelf changes
//                     const locationCode = `${formData.floor || ''}-${formData.rack || ''}-${value || ''}`;
//                     setFormData(prev => ({
//                         ...prev,
//                         shelf: value,
//                         full_location_code: locationCode
//                     }));
//                     if (setFieldState) {
//                         setFieldState('full_location_code', {
//                             helpText: `Generated: ${locationCode}`
//                         });
//                     }
//                 }
//             },
//             {
//                 name: "name",
//                 label: "Category Name",
//                 type: "select",
//                 asyncSelect: true,
//                 required: true,
//                 placeholder: "Search or create category",
//                 helpText: "Search existing categories or type new name to create. Supports DDC (000-099) and LLC (AC-AZ) classifications.",
//                 colSize: 6,
//                 loadOptions: async (inputValue) => {
//                     try {
//                         const api = (await import('../../api/dataApi')).default;
//                         const classificationApi = new api('classification');
//                         const response = await classificationApi.get('/');
//                         const classifications = response.data || [];

//                         // Filter by input value and library classification setting
//                         const filtered = classifications.filter(item => {
//                             // Only show if it matches the library standard
//                             if (configClassification && item.classification_type !== configClassification) {
//                                 return false;
//                             }

//                             if (!inputValue) return true;

//                             const searchValue = inputValue.toLowerCase().trim();

//                             // Direct name/category matching
//                             if (item.category?.toLowerCase().includes(searchValue) ||
//                                 item.name?.toLowerCase().includes(searchValue)) {
//                                 return true;
//                             }

//                             // Code matching (exact or partial)
//                             if (item.code?.toLowerCase().includes(searchValue)) {
//                                 return true;
//                             }

//                             // Range matching - only for same classification type
//                             if (item.classification_from && item.classification_to) {
//                                 // Check if both item and search are numeric (DDC)
//                                 const isItemNumeric = /^\d+$/.test(item.classification_from) && /^\d+$/.test(item.classification_to);
//                                 const isSearchNumeric = /^\d+$/.test(searchValue);

//                                 // Check if both item and search are alphabetic (LLC)
//                                 const isItemAlpha = /^[a-zA-Z]+$/.test(item.classification_from) && /^[a-zA-Z]+$/.test(item.classification_to);
//                                 const isSearchAlpha = /^[a-zA-Z]+$/.test(searchValue);

//                                 // For numeric ranges (DDC)
//                                 if (isItemNumeric && isSearchNumeric) {
//                                     const searchNum = parseInt(searchValue);
//                                     const fromNum = parseInt(item.classification_from);
//                                     const toNum = parseInt(item.classification_to);

//                                     if (searchNum >= fromNum && searchNum <= toNum) {
//                                         return true;
//                                     }
//                                 }

//                                 // For alphabetic ranges (LLC)
//                                 else if (isItemAlpha && isSearchAlpha) {
//                                     const searchAlpha = searchValue.toUpperCase();
//                                     const fromAlpha = item.classification_from.toUpperCase();
//                                     const toAlpha = item.classification_to.toUpperCase();

//                                     // Simple alphabetical range check
//                                     if (searchAlpha >= fromAlpha && searchAlpha <= toAlpha) {
//                                         return true;
//                                     }
//                                 }
//                             }

//                             return false;
//                         });

                           

//                         // Create options with detailed information
//                         return filtered.map(item => ({
//                             value: item.name,
//                             label: `${item.category} - ${item.name} (${item.code}) [${item.classification_from || '0'} to ${item.classification_to || '0'}]`,
//                             data: item
//                         }));
//                     } catch (e) {
//                         console.error("Error loading classifications:", e);
//                         return [];
//                     }
//                 },

             
//                 defaultOptions: true,
//                 clearable: true,
//                 creatable: true,
//                 onChange: async (selectedOption, formData, setFormData, setFieldState) => {
//                     if (selectedOption) {

//                         const selected = selectedOption.data;

//                         setFormData(prev => ({
//                             ...prev,
//                             name: selectedOption.value,
//                             classification_from: selected.classification_from || '',
//                             classification_to: selected.classification_to || '',
//                             classification_type: selected.classification_type || ''
//                         }));

//                         if (setFieldState) {
//                             setFieldState('classification_from', {
//                                 helpText: `Auto-filled: ${selected.classification_from}`
//                             });
//                             setFieldState('classification_to', {
//                                 helpText: `Auto-filled: ${selected.classification_to}`
//                             });
//                             setFieldState('classification_type', {
//                                 helpText: `Auto-filled: ${selected.classification_type}`
//                             });
//                         }

//                     } else {
//                         setFormData(prev => ({
//                             ...prev,
//                             name: '',
//                             classification_from: '',
//                             classification_to: '',
//                             classification_type: ''
//                         }));
//                     }
//                 }

//             },
         
//             {
//                 name: "classification_from",
//                 label: "Range From",
//                 type: "text",
//                 required: false,
//                 placeholder: "Auto-filled",
//                 colSize: 6,
//                 readOnly: true,
//                 helpText: "Auto-filled from category selection"
//             },
//             {
//                 name: "classification_to",
//                 label: "Range To",
//                 type: "text",
//                 required: false,
//                 placeholder: "Auto-filled",
//                 colSize: 6,
//                 readOnly: true,
//                 helpText: "Auto-filled from category selection"
//             },
//             {
//                 name: "classification_type",
//                 label: "Classification Type",
//                 type: "text",
//                 required: false,
//                 placeholder: "Auto-filled",
//                 colSize: 6,
//                 readOnly: true,
//                 helpText: "Auto-filled from category selection"
//             },
//             {
//                 name: "capacity",
//                 label: "Capacity",
//                 type: "number",
//                 required: true,
//                 placeholder: "Enter capacity",
//                 defaultValue: 100,
//                 min: 1,
//                 colSize: 6,
//             },
//             // {
//             //     name: "is_active",
//             //     label: "Active",
//             //     type: "checkbox",
//             //     required: false,
//             //     colSize: 6,
//             // },
//             {
//                 name: "is_active",
//                 label: "Status",
//                 type: "toggle",
//                 colSize: 6,

//                 // options: [
//                 //     { value: true, label: "Active" },
//                 //     { value: false, label: "Inactive" }
//                 // ],
//                 defaultValue: true
//             },
//         ],

//         validationRules: (formData, allShelves, editingItem) => {
//              const errors = [];
//             if (!formData.floor?.trim()) {
//                 errors.push("Floor number or level is required.");
//             }

//             if (!formData.rack?.trim()) {
//                 errors.push("Rack identifier (e.g., RACK-01) is required.");
//             }

//             if (!formData.shelf?.trim()) {
//                 errors.push("Shelf number/name is required.");
//             }

//             if (!formData.name?.trim()) {
//                 errors.push("Category selection is required for mapping.");
//             }

//             if (formData.name?.trim()) {
//                 if (!formData.classification_from?.trim()) {
//                     errors.push("Missing 'Range From' code for the selected category.");
//                 }

//                 if (!formData.classification_to?.trim()) {
//                     errors.push("Missing 'Range To' code for the selected category.");
//                 }

//                 if (!formData.classification_type?.trim()) {
//                     errors.push("Classification type (DDC/LLC) is required.");
//                 }

//                 // Logical check if both are present
//                 if (formData.classification_from && formData.classification_to) {
//                     const from = formData.classification_from.trim();
//                     const to = formData.classification_to.trim();

//                     // Simple numeric check for DDC
//                     if (!isNaN(from) && !isNaN(to)) {
//                         if (parseFloat(from) > parseFloat(to)) {
//                             errors.push("Invalid DDC range: 'From' cannot be greater than 'To'.");
//                         }
//                     }
//                 }
//             }

//             // Check for physical location duplicates (Floor + Rack + Shelf)
//             const duplicateLocation = allShelves.find(
//                 shelf =>
//                     shelf.floor?.toLowerCase() === formData.floor?.toLowerCase() &&
//                     shelf.rack?.toLowerCase() === formData.rack?.toLowerCase() &&
//                     shelf.shelf?.toLowerCase() === formData.shelf?.toLowerCase() &&
//                     shelf.id !== editingItem?.id
//             );

//             if (duplicateLocation) {
//                 errors.push(`Location ${formData.floor}-${formData.rack}-${formData.shelf} is already assigned to category '${duplicateLocation.name}'.`);
//             }

//             const capacity = parseInt(formData.capacity);
//             if (isNaN(capacity) || capacity <= 0) {
//                 errors.push("Capacity must be a positive number.");
//             }
//             if (!formData.name?.trim()) {
//                 errors.push("Category Name is required");
//             }

//             // const duplicateName = allShelves.find(
//             //     shelf => shelf.name?.toLowerCase() === formData.name?.toLowerCase() &&
//             //         shelf.id !== editingItem?.id
//             // );
//             // console.log("duplicate",duplicateName)
//             // if (duplicateName) {
//             //     errors.push("Category with this name already exists");
//             // }
//             return errors;
//         },

//         features: {
//             showBulkInsert: false,
//             showImportExport: true,
//             showDetailView: true,
//             showSearch: true,
//             showColumnVisibility: true,
//             showCheckbox: true,
//             showActions: true,
//             showAddButton: true,
//             allowEdit: permissions?.allowEdit ?? true,
//             allowDelete: permissions?.allowDelete ?? true,
//             showImportButton: true,
//             showAdvancedFilter: true,
//             permissions: permissions || {},
//         },

//         filterFields: [
//             {
//                 name: "name",
//                 label: "Name",
//                 type: "text",
//                 placeholder: "Search by name"
//             },
//             {
//                 name: "floor",
//                 label: "Floor",
//                 type: "text",
//                 placeholder: "Search by floor"
//             },
//             {
//                 name: "rack",
//                 label: "Rack",
//                 type: "text",
//                 placeholder: "Search by rack"
//             }
//         ],

//         customHandlers: {
//             beforeSave: (formData, editingItem) => {
//                 if (formData.capacity) {
//                     formData.capacity = parseInt(formData.capacity);
//                 }
//                 return true;
//             },
//             afterSave: (response, editingItem) => {
//                 console.log("Shelf saved:", response);
//             }
//         },

//         details: [
//             { key: "name", label: "Name", type: "text" },
//             { key: "floor", label: "Floor", type: "text" },
//             { key: "rack", label: "Rack", type: "text" },
//             { key: "shelf", label: "Shelf", type: "text" },
//             { key: "classification_from", label: "Range From", type: "text" },
//             { key: "classification_to", label: "Range To", type: "text" },
//             { key: "capacity", label: "Capacity", type: "text" },
//             { key: "full_location_code", label: "Full Location Code", type: "text" },
//             { key: "is_active", label: "Active", type: "boolean" },
//             { key: "createddate", label: "Created Date", type: "date" },
//             { key: "lastmodifieddate", label: "Last Modified Date", type: "date" },
//             { key: "createdbyid", label: "Created By", type: "text" },
//             { key: "lastmodifiedbyid", label: "Last Modified By", type: "text" },
//         ]
//     };
// };

import { Badge, ProgressBar } from "react-bootstrap";
import { createModel } from "../common/UniversalCSVXLSXImporter";

export const getShelfConfig = (
    externalData = {},
    props = {},
    permissions = {}
) => {

    const ShelfModel = createModel({
        modelName: "Shelf",
        fields: {
            name: "Name",
            floor: "Floor",
            rack: "Rack",
            shelf: "Shelf",
            classification_type: "Classification Type",
            classification_from: "From Range",
            classification_to: "To Range",
            capacity: "Capacity",
            full_location_code: "Full Location Code",
            is_active: "Active"
        },
        required: ["name", "floor", "rack", "shelf"]
    });

    // Get library settings from external data
    const librarySettings = externalData?.["librarysettings"] || [];
    const settings = Array.isArray(librarySettings) ? librarySettings[0] : (librarySettings.data || {});
    const configClassification = settings?.config_classification || "";
    
    return {
        moduleName: "shelf",
        moduleLabel: "Rack Mapping",
        apiEndpoint: "shelf",

        dataDependencies: {
            librarysettings: 'librarysettings'
        },

        importMatchFields: ["name", "floor", "rack"],
        importModel: ShelfModel,

        initialFormData: (editingItem) => {
            if (editingItem) {
                return {
                    name: editingItem.name || "",
                    floor: editingItem.floor || "",
                    rack: editingItem.rack || "",
                    shelf: editingItem.shelf || "",
                    classification_type: editingItem.classification_type || "",
                    classification_from: editingItem.classification_from || "",
                    classification_to: editingItem.classification_to || "",
                    capacity: editingItem.capacity || 100,
                    is_active: editingItem.is_active !== undefined ? editingItem.is_active : true
                };
            }

            return {
                name: "",
                floor: "",
                rack: "",
                shelf: "",
                classification_type: "",
                classification_from: "",
                classification_to: "",
                capacity: 100,
                is_active: true
            };
        },

        columns: [
            { field: "name", label: "Name", width: "200px" },
            { field: "floor", label: "Floor", width: "100px", render: (value) => <span className="font-monospace">{value || '-'}</span> },
            { field: "rack", label: "Rack", width: "100px", render: (value) => <span className="font-monospace">{value || '-'}</span> },
            { field: "shelf", label: "Shelf", width: "100px", render: (value) => <span className="font-monospace">{value || '-'}</span> },
            { field: "classification_type", label: "Type", width: "100px", render: (value) => <span className="badge bg-info">{value || '-'}</span> },
            { field: "classification_from", label: "From", width: "80px", render: (value) => <span className="text-info font-monospace">{value || '-'}</span> },
            { field: "classification_to", label: "To", width: "80px", render: (value) => <span className="text-info font-monospace">{value || '-'}</span> },
            { field: "full_location_code", label: "Location", width: "150px", render: (value) => <span className="font-monospace">{value || '-'}</span> },
            { field: "capacity", label: "Capacity", width: "150px", render: (value) => <span>{parseInt(value) || 100}</span> },
            { field: "is_active", label: "Active", width: "100px", render: (value) => <Badge bg={value ? "success" : "danger"}>{value ? "Active" : "Inactive"}</Badge> }
        ],

        formFields: [
            {
                name: "floor",
                label: "Floor",
                type: "text",
                required: true,
                placeholder: "Enter floor",
                colSize: 6,
                // Matched parameters: fieldName, val, formData, setFormData
                onChange: (fieldName, val, formData, setFormData) => {
                    const locationCode = `${val || ''}-${formData.rack || ''}-${formData.shelf || ''}`;
                    setFormData(prev => ({
                        ...prev,
                        [fieldName]: val,
                        full_location_code: locationCode
                    }));
                }
            },
            {
                name: "rack",
                label: "Rack",
                type: "text",
                required: true,
                placeholder: "Enter rack number (e.g., RACK-01)",
                colSize: 6,
                onChange: (fieldName, val, formData, setFormData) => {
                    const locationCode = `${formData.floor || ''}-${val || ''}-${formData.shelf || ''}`;
                    setFormData(prev => ({
                        ...prev,
                        [fieldName]: val,
                        full_location_code: locationCode
                    }));
                }
            },
            {
                name: "shelf",
                label: "Shelf",
                type: "text",
                required: true,
                placeholder: "Enter shelf (e.g., SHELF-A)",
                colSize: 6,
                onChange: (fieldName, val, formData, setFormData) => {
                    const locationCode = `${formData.floor || ''}-${formData.rack || ''}-${val || ''}`;
                    setFormData(prev => ({
                        ...prev,
                        [fieldName]: val,
                        full_location_code: locationCode
                    }));
                }
            },
            {
                name: "name",
                label: "Category Name",
                type: "select",
                asyncSelect: true,
                required: true,
                placeholder: "Search or create category",
                helpText: "Search existing categories or type new name to create. Supports DDC (000-099) and LLC (AC-AZ) classifications.",
                colSize: 6,
                loadOptions: async (inputValue) => {
                    try {
                        const api = (await import('../../api/dataApi')).default;
                        const classificationApi = new api('classification');
                        const response = await classificationApi.get('/');
                        const classifications = response.data || [];

                        const filtered = classifications.filter(item => {
                            if (configClassification && item.classification_type !== configClassification) return false;
                            if (!inputValue) return true;

                            const searchValue = inputValue.toLowerCase().trim();
                            if (item.category?.toLowerCase().includes(searchValue) || item.name?.toLowerCase().includes(searchValue)) return true;
                            if (item.code?.toLowerCase().includes(searchValue)) return true;

                            if (item.classification_from && item.classification_to) {
                                const isItemNumeric = /^\d+$/.test(item.classification_from) && /^\d+$/.test(item.classification_to);
                                const isSearchNumeric = /^\d+$/.test(searchValue);
                                const isItemAlpha = /^[a-zA-Z]+$/.test(item.classification_from) && /^[a-zA-Z]+$/.test(item.classification_to);
                                const isSearchAlpha = /^[a-zA-Z]+$/.test(searchValue);

                                if (isItemNumeric && isSearchNumeric) {
                                    const searchNum = parseInt(searchValue);
                                    if (searchNum >= parseInt(item.classification_from) && searchNum <= parseInt(item.classification_to)) return true;
                                } else if (isItemAlpha && isSearchAlpha) {
                                    const searchAlpha = searchValue.toUpperCase();
                                    if (searchAlpha >= item.classification_from.toUpperCase() && searchAlpha <= item.classification_to.toUpperCase()) return true;
                                }
                            }
                            return false;
                        });

                        return filtered.map(item => ({
                            value: item.name,
                            label: `${item.category} - ${item.name} (${item.code}) [${item.classification_from || '0'} to ${item.classification_to || '0'}]`,
                            data: item
                        }));
                    } catch (e) {
                        console.error("Error loading classifications:", e);
                        return [];
                    }
                },
                defaultOptions: true,
                clearable: true,
                creatable: true,
                // Uses the new 5th parameter (originalOption) to extract the `.data` object
                onChange: (fieldName, val, formData, setFormData, originalOption) => {
                    if (typeof setFormData !== 'function') return;

                    if (originalOption && originalOption.data) {
                        const selected = originalOption.data;
                        setFormData(prev => ({
                            ...prev,
                            name: val,
                            classification_from: selected.classification_from || '',
                            classification_to: selected.classification_to || '',
                            classification_type: selected.classification_type || ''
                        }));
                    } else {
                        setFormData(prev => ({
                            ...prev,
                            name: val || '',
                            classification_from: '',
                            classification_to: '',
                            classification_type: ''
                        }));
                    }
                }
            },
            {
                name: "classification_from",
                label: "Range From",
                type: "text",
                required: false,
                placeholder: "Auto-filled",
                colSize: 6,
                readOnly: true,
                helpText: "Auto-filled from category selection"
            },
            {
                name: "classification_to",
                label: "Range To",
                type: "text",
                required: false,
                placeholder: "Auto-filled",
                colSize: 6,
                readOnly: true,
                helpText: "Auto-filled from category selection"
            },
            {
                name: "classification_type",
                label: "Classification Type",
                type: "text",
                required: false,
                placeholder: "Auto-filled",
                colSize: 6,
                readOnly: true,
                helpText: "Auto-filled from category selection"
            },
            {
                name: "capacity",
                label: "Capacity",
                type: "number",
                required: true,
                placeholder: "Enter capacity",
                defaultValue: 100,
                min: 1,
                colSize: 6,
            },
            {
                name: "is_active",
                label: "Status",
                type: "toggle",
                colSize: 6,
                defaultValue: true
            },
        ],

        validationRules: (formData, allShelves, editingItem) => {
             const errors = [];
            if (!formData.floor?.trim()) errors.push("Floor number or level is required.");
            if (!formData.rack?.trim()) errors.push("Rack identifier (e.g., RACK-01) is required.");
            if (!formData.shelf?.trim()) errors.push("Shelf number/name is required.");
            if (!formData.name?.trim()) errors.push("Category selection is required for mapping.");

            if (formData.name?.trim()) {
                if (!formData.classification_from?.trim()) errors.push("Missing 'Range From' code for the selected category.");
                if (!formData.classification_to?.trim()) errors.push("Missing 'Range To' code for the selected category.");
                if (!formData.classification_type?.trim()) errors.push("Classification type (DDC/LLC) is required.");

                if (formData.classification_from && formData.classification_to) {
                    const from = formData.classification_from.trim();
                    const to = formData.classification_to.trim();
                    if (!isNaN(from) && !isNaN(to)) {
                        if (parseFloat(from) > parseFloat(to)) {
                            errors.push("Invalid DDC range: 'From' cannot be greater than 'To'.");
                        }
                    }
                }
            }

            const duplicateLocation = allShelves.find(
                shelf =>
                    shelf.floor?.toLowerCase() === formData.floor?.toLowerCase() &&
                    shelf.rack?.toLowerCase() === formData.rack?.toLowerCase() &&
                    shelf.shelf?.toLowerCase() === formData.shelf?.toLowerCase() &&
                    shelf.id !== editingItem?.id
            );

            if (duplicateLocation) {
                errors.push(`Location ${formData.floor}-${formData.rack}-${formData.shelf} is already assigned to category '${duplicateLocation.name}'.`);
            }

            const capacity = parseInt(formData.capacity);
            if (isNaN(capacity) || capacity <= 0) {
                errors.push("Capacity must be a positive number.");
            }
            return errors;
        },

        features: {
            showBulkInsert: false,
            showImportExport: true,
            showDetailView: true,
            showSearch: true,
            showColumnVisibility: true,
            showCheckbox: true,
            showActions: true,
            showAddButton: true,
            allowEdit: permissions?.allowEdit ?? true,
            allowDelete: permissions?.allowDelete ?? true,
            showImportButton: true,
            showAdvancedFilter: true,
            permissions: permissions || {},
        },

        filterFields: [
            { name: "name", label: "Name", type: "text", placeholder: "Search by name" },
            { name: "floor", label: "Floor", type: "text", placeholder: "Search by floor" },
            { name: "rack", label: "Rack", type: "text", placeholder: "Search by rack" }
        ],

        customHandlers: {
            beforeSave: (formData, editingItem) => {
                if (formData.capacity) formData.capacity = parseInt(formData.capacity);
                return true;
            },
            afterSave: (response, editingItem) => {
                console.log("Shelf saved:", response);
            }
        },

        details: [
            { key: "name", label: "Name", type: "text" },
            { key: "floor", label: "Floor", type: "text" },
            { key: "rack", label: "Rack", type: "text" },
            { key: "shelf", label: "Shelf", type: "text" },
            { key: "classification_from", label: "Range From", type: "text" },
            { key: "classification_to", label: "Range To", type: "text" },
            { key: "capacity", label: "Capacity", type: "text" },
            { key: "full_location_code", label: "Full Location Code", type: "text" },
            { key: "is_active", label: "Active", type: "boolean" },
            { key: "createddate", label: "Created Date", type: "date" },
            { key: "lastmodifieddate", label: "Last Modified Date", type: "date" },
            { key: "createdbyid", label: "Created By", type: "text" },
            { key: "lastmodifiedbyid", label: "Last Modified By", type: "text" },
        ]
    };
};